import DataTable from 'Components/DataTable';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import BlockWrapper from 'Components/_NewElements/BlockWrapper';
import { dss } from 'neuro-schemas';
import { formatPartialDate } from 'Utility/date';
import * as React from 'react';
import { useMyServiceContext } from '../..';
import colors from '../../../../../config/theme/colors';
import { formatScore } from 'Routes/MyService/util';
import browserLanguage from 'Utility/browserLanguage';
import { useAppSelector } from 'Store/index';

const {
  calculateProgress,
  utils: { mapFieldValueToNumberValue },
} = dss;

const dssFields: Array<keyof IDSS> = [
  'wakingUpAtNight',
  'morningHeadache',
  'wakingUpRefreshed',
  'tiredDuringDay',
  'shortnessOfBreathAtNight',
];

export const Dss = (): React.JSX.Element => {
  const locale = useAppSelector(s => s.settings.userSettings.uiLanguage) ?? browserLanguage;
  const { editing, setEditingData, viewing, setViewingObj, setEditingObj } = useMyServiceContext<'dss'>();
  const dssData = editing?.data ?? viewing?.data ?? {};
  const dssLocales = dss.getLocalizations(locale);

  const onChangeSurveyForm = (values: TOnChangeValues): void => {
    const field = Object.keys(values)[0];
    if (!field) return;
    const value = Object.values(values)[0];
    setEditingData?.({
      ...dssData,
      [field]: value,
    });
  };
  return (
    <>
      <BlockWrapper
        title={viewing ? formatPartialDate(dssData.date) : undefined}
        buttons={
          viewing
            ? [
                {
                  title: 'general.edit',
                  onClick: () => {
                    setViewingObj(null);
                    setEditingObj({ type: 'dss', data: dssData });
                  },
                },
              ]
            : undefined
        }
      >
        {!viewing && (
          <FormRow title={'general.date'} headerWidth={4.2}>
            <InputHandler
              name="date"
              type="PartialDate"
              dateDefault="now"
              formData={{
                document: { date: dssData.date },
                onChange: onChangeSurveyForm,
              }}
              editing={!!editing}
            />
          </FormRow>
        )}
        <div style={{ width: '60%', marginBottom: '2rem', marginTop: viewing ? '6rem' : undefined }}>
          <DataTable
            headers={viewing ? ['', '', ''] : ['', '']}
            data={{
              rowData: dssFields.map(f => {
                const opts = ['never', 'occasionally', 'sometimes', 'always'];
                const rowSet = [
                  dssLocales[f] ?? '-',
                  <InputHandler
                    key={f}
                    name={f}
                    type="Radio"
                    editing={!!editing}
                    formData={{
                      document: { [f]: dssData[f] },
                      onChange: onChangeSurveyForm,
                    }}
                    options={f === 'wakingUpRefreshed' ? opts.slice().reverse() : opts}
                    optionFormatter={o => dssLocales[`opts.${o}`] ?? '-'}
                  />,
                ];
                if (viewing && f !== 'date') {
                  rowSet.push(
                    <span style={{ fontWeight: 600 }}>{mapFieldValueToNumberValue(f, dssData[f]) ?? ''}</span>,
                  );
                }
                return rowSet;
              }),
              rowStyle: viewing ? undefined : dssFields.map(() => ({ rowAlign: 'top' })),
            }}
          />
        </div>
        <FormRow
          title="myService.sleepApnea.dss.score"
          headerStyle={{ fontWeight: 600 }}
          headerWidth={viewing ? 6.7 : 4.2}
        >
          <div style={{ color: colors.tertiaryText, fontWeight: 600 }}>
            {(() => {
              const { yielded, ceiling } = calculateProgress(dssData);
              return formatScore({ yielded, ceiling });
            })()}
          </div>
        </FormRow>
      </BlockWrapper>
    </>
  );
};
